module.exports = __webpack_public_path__ + "021c9dad239b10734acb94367739c822.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 502
// module chunks = 0